import { createActionCreators } from 'store/utils/actionHelpers'
import types from './types'
import CmsApis from 'apis/cmsApis'

const {
  fetchStoreTemplatesRequest,
  fetchStoreTemplatesSuccess,
  fetchStoreTemplatesFailure,
} = createActionCreators(types)

export const fetchStoreTemplates = () => (dispatch) => {
  dispatch(fetchStoreTemplatesRequest())
  return CmsApis.getStoreTemplates()
    .then(({ data }) => {
      // set storeId to CmsApi class
      // so that next time we call an api, storeId will be attached to headers
      return dispatch(fetchStoreTemplatesSuccess(data))
    })
    .catch((error) => dispatch(fetchStoreTemplatesFailure({ error })))
}



// WEBPACK FOOTER //
// ./src/store/storeTemplates/actions.js